import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M7 5h10v14H7z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
})), 'StayPrimaryPortraitTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/StayPrimaryPortraitTwoTone.js
// module id = 6502
// module chunks = 2